module.exports = "/assets/site/images/tenisz.jpg?606f78ebde7fd9ac1319b06423e94022";